<mat-sidenav-container>

    <mat-sidenav #sidenav mode="side" opened class="filters">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <app-line-direction-counters-reset-menu></app-line-direction-counters-reset-menu>
            <app-carrier-selector formControlName="carrier"></app-carrier-selector>
            <importer-stp-line-selector formControlName="line" [carrierId]="form.value.carrier" [multiple]="false" [trimValue]="true"
                [type]="'number'"></importer-stp-line-selector>
            <div class="actions">
                <button mat-raised-button color="sims" type="reset" (click)="handleFormClear()">
                    {{'accumulated-data-report.clear'| translate | capitalizeFirst }}
                </button>
                <button mat-raised-button color="sims" type="submit" [disabled]="form.invalid || !hasChanged">
                    {{'accumulated-data-report.lookup'| translate | capitalizeFirst }}
                </button>
            </div>
        </form>
    </mat-sidenav>

    <mat-sidenav-content class="sidenav-content">
        <app-sidenav-toggle [sidenav]="sidenav"></app-sidenav-toggle>
        <div class="table-layout">
            <div class="header">
                <h1>{{ 'line-direction-counters-resets.list-component' | translate }}</h1>
            </div>
            <div class="table-scroll">
                <p-table class="reset-list-table" [value]="filteredData" [scrollable]="true" scrollHeight="flex"
                    styleClass="p-datatable-gridlines" [loading]="loading" selectionMode="single" dataKey="id">
                    <ng-template pTemplate="colgroup" let-columns>
                        <colgroup>
                            <col [style.width]="'220px' + ' !important'">
                            <col>
                            <col [style.width]="'120px' + ' !important'">
                        </colgroup>
                    </ng-template>

                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th class="table-header"> {{ 'line-direction-counters-resets.line' | translate | capitalizeFirst }} </th>
                            <th class="table-header"> {{ 'line-direction-counters-resets.direction' | translate | capitalizeFirst }} </th>
                            <th class="table-header"></th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr [pSelectableRow]="rowData">
                            <td class="table-cell">{{ rowData?.line }}</td>
                            <td class="table-cell">{{ rowData?.direction }}</td>
                            <td class="table-cell" style="display: flex; justify-content: space-between;">
                                <button pButton type="button" icon="pi pi-trash" class="p-button-text p-button-sm p-button-danger"
                                    (click)="onDelete(rowData)">
                                </button>
                                <button pButton type="button" icon="pi pi-arrow-right" class=" p-button-text p-button-sm"
                                    [routerLink]="['../edit']" [queryParams]="{ id: rowData.id }">
                                </button>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>

    </mat-sidenav-content>

</mat-sidenav-container>